import usePropsContext from '/druid/internal/usePropsContext';

export default function useStyleSetClassNames() {
  const { styleSetClassNames } = usePropsContext();

  return [styleSetClassNames];
}
